/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicSeriesType } from '../../models/public-series-type';

export interface ConnectorGetSeriesTypes$Params {
}

export function connectorGetSeriesTypes(http: HttpClient, rootUrl: string, params?: ConnectorGetSeriesTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicSeriesType>>> {
  const rb = new RequestBuilder(rootUrl, connectorGetSeriesTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicSeriesType>>;
    })
  );
}

connectorGetSeriesTypes.PATH = '/apollon-connector/enums/series-types';
